// API URL resolution: use relative URLs in production (same-origin),
// full URL in development (proxy needs it)
const envUrl = process.env.REACT_APP_BACKEND_URL || '';

// In production builds, if the baked-in URL contains "emergent.host",
// use empty string (relative URL = same origin) for faster API calls
const isSlowProductionProxy = envUrl.includes('.emergent.host');
export const API_URL = isSlowProductionProxy ? '' : envUrl;
